import { AxiosError } from 'axios';

export const getErrorMessage = (error: unknown): string => {
	if (!error) {
		return 'Unknown error';
	}

	if (error instanceof AxiosError) {
		const data = error.response?.data;

		console.log('BACKEND ERROR:', data);

		// Array response
		if (Array.isArray(data)) {
			return data.join('\n | ');
		}

		// message string
		if (typeof data?.message === 'string') {
			return data.message;
		}

		// message array
		if (Array.isArray(data?.message)) {
			return data.message.join('\n | ');
		}

		// fallback object
		if (typeof data === 'object') {
			return JSON.stringify(data);
		}

		return error.message;
	}

	if (error instanceof Error) {
		return error.message;
	}

	return String(error);
};
